<app-base-layout [showFooter]="false" [darkMode]="true">
  <div class="application-sent-page-content">
    <img
      src="assets/application-sent.svg"
      alt="Imagem De Proposta Enviada"
      class="application-sent-content-image"
    />
    <h1 [innerHTML]="messageTitle | safeHtml"></h1>

    <div [innerHTML]="messageBody | safeHtml"></div>
    <!-- <div class="application-sent-page-content-phone">
      <h2>Telefone Principal:</h2>
      <p>{{ phoneNumber }}</p>
    </div> -->

    <div [innerHTML]="messageFooter | safeHtml"></div>
  </div>
</app-base-layout>
